<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount">
            <div>
              <AmountSelector />
              <ErrorLabel field="amount" />
            </div>
            <br />
            <InHonorOf />
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>

          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
              <Consent privacy="https://www.ou.org/privacy-policy/"/>
          </FormRow>              
            <FormRow>
                <div style="width: 100%" class="coupon__field">
                  <FormLabel class="control-label"> Organization </FormLabel>
                  <FormInput type="text" class="width-half" field="custom.organization"/>
                </div>
              </FormRow> 
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow>
              <Receipt />
            </FormRow>               
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import { queryParams } from "~/shared/query-params";

export default defineComponent({

  props: {},
  setup() {
    const { setValue, getValue, form } = usePaymentForm();

    return {
      form,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep.form-container.ou-donation-form {
  // padding: 0px;
  // margin: 0px;
  // box-shadow: none;
  // border: none;
  // max-width: 100%;
}
::v-deep h2 {
  font-style: normal;
  font-weight: 700 !important;
  font-size: 16px !important;
  margin-bottom: 16px !important;
  line-height: 24px !important;
  color: #133271 !important;
}
::v-deep hr {
  display: none;
  margin: 0px;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
::v-deep .radio-inline {
  margin-left: 20px !important;
}

::v-deep .control-label {
  flex: 1;
  max-width: 100%;
  padding-top: 3px;
  line-height: normal;
  padding-bottom: 3px;
  display: block;
  font-size: 14px;
  color: #222;
}
.sponsorship__list {
  display: flex;
  gap: 16px;
  width: 100%;

  @media only screen and (max-width: 500px) {
    flex-flow: column;
  }
}
.amount-row {
  width: 100%;
  flex: 1;

  label {
    cursor: pointer;
    height: 100%;
    width: 100%;
    padding: 20px 24px;
    background: #ffffff;
    border: 2px solid #ebebeb;
    border-radius: 8px;
    &:hover {
      background: #fafafa;
    }
    @media only screen and (max-width: 500px) {
      padding: 10px 14px;
    }
  }
  input {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }

  input[type="radio"]:checked + label {
    border: 2px solid #1e50b4;
    .money_format {
      color: #1e50b4;
    }
    .label-description {
      color: #080f16;
    }
  }
}
.money_format {
  font-family: "Proxima Nova";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  margin-bottom: 8px;
  color: #080f16;
}
.label-description {
  font-family: "Proxima Nova";
  font-style: italic;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: #595c5f;
}
</style>
